<template>
    <div class="main">
        <div class="sidebar">
            <sidebarComponent></sidebarComponent>
        </div>
        <div class="content-right">

            <navbarComponent></navbarComponent>

            <div class="pages">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>

    import sidebarComponent from "./components/sidebarComponent";
    import navbarComponent from "./components/navbarComponent";



    export default {

        name: "homeComponent",
        components: {
            sidebarComponent,
            navbarComponent,

    }
    }
</script>

<style lang="scss" src="./style.scss" scoped>

</style>
